import angular from 'angular'

const listPage = require('./view/list.html')
const listCtrl = require('./list')
const riskWarningModalCtrl = require('../fullEleInvoice/riskWarningModal')
const fullEleInvoiceChooseUkeyModal = require('../fullEleInvoice/fullEleInvoiceChooseUkeyModal')

function configRouter($stateProvider) {
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoiceIsAbnormal', {
        url: '/fullEleInvoiceIsAbnormal',
        abstract: true,
        template: '<div ui-view></div>',
        default: 'outputManage.fullElectricInvoice.fullEleInvoiceIsAbnormal.list',
        title: '数电发票异常',
    })
    $stateProvider.state('outputManage.fullElectricInvoice.fullEleInvoiceIsAbnormal.list', {
        url: '/list',
        template: listPage,
        controller: 'fullEleInvoiceIsAbnormalListCtrl',
    })
}

export default angular
    .module('outputManage.fullElectricInvoice.fullEleInvoiceIsAbnormal', [])
    .config(['$stateProvider', configRouter])
    .controller('riskWarningModalCtrl', riskWarningModalCtrl.default)
    .controller('fullEleInvoiceChooseUkeyModal', fullEleInvoiceChooseUkeyModal.default)
    .controller('fullEleInvoiceIsAbnormalListCtrl', listCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/fullEleInvoiceIsAbnormal/index.js